import Vue from 'vue'
import Container from './components/Container.vue'
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'
import "popper.js"
import "bootstrap/dist/js/bootstrap.min"
import BootstrapVue from 'bootstrap-vue'
import VuejsDialog from 'vuejs-dialog';
import VueCarousel from 'vue-carousel';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';

Vue.use(VueRouter);
Vue.use(VueMeta);
Vue.use(BootstrapVue);
Vue.use(VueCarousel);
Vue.use(VuejsDialog, {
    html: true, loader: false, okText: 'המשך', cancelText: 'סגור', animation: 'bounce',
});
const router = new VueRouter({
    mode: 'history', routes: [{
        path: '/', component: App, props: {code: 'BE51'}
    }, {
        path: '/v/', name: "vote", component: App, props: {code: 'BE51'}
    }, {
        path: '/v/:code', name: "voteCode", component: App, props: true,
    }, {
        path: '/access/:code/:accessToken', name: "voteResults", component: App, props: true,
    }]
})

Vue.config.productionTip = false;
new Vue({
    router, render: h => h(Container),
}).$mount('#app');
